import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react'
import React, { useState } from 'react'
import { IHeaderProps } from '../interfaces/Header.Interface'
import Icon from '../../svg/Icon'
import Conditional from '../../common/Conditional'
import useLoggedInCookie from '../../../hooks/useLoggedInCookie'
import { PATHS } from '../../Routes'
import { Link } from 'react-router-dom'

export const Header = ({
  active,
  openClick,
  searchClick,
  showMegamenu,
}: IHeaderProps) => {
  const { instance } = useMsal()
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const [, removeLoggedInCookie] = useLoggedInCookie()
  const registrationUrl = process.env.REACT_APP_AZURE_B2C_REGISTRATION_URL
  const [isActive, setIsActive] = useState(false)
  const isRegisterPage = window.location.href.includes('/my-account/register')
  const toggleClass = () => {
    setIsActive((isActive) => !isActive)
  }
  return (
    <>
      <header className={active ? 'site-header sr-only' : 'site-header'}>
        <Conditional if={showMegamenu}>
          <div id="menu-button" className="js-menu-button" aria-hidden="true">
            <a href="!#" onClick={openClick} tabIndex={0} aria-hidden="true">
              <Icon name="menu" />
              Menu
            </a>
          </div>
        </Conditional>
        <span className="logo left">
          <a href={govCMSHome}>
            <Icon name="fairwork" />
            <span className="sr-only">Go to home page</span>
          </a>
        </span>
        <Conditional if={showMegamenu}>
          <AuthenticatedTemplate>
            <a
              href="/my-account"
              className="my-account-menu button"
              id="myAccountButton"
            >
              MY ACCOUNT
            </a>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <button
              className="my-account-menu button"
              id="authenticationButtonLogin"
              onClick={() => instance.loginRedirect()}
            >
              Login
            </button>
            <a className="my-account-menu button" href={registrationUrl}>
              Register
            </a>
          </UnauthenticatedTemplate>
        </Conditional>
        <Conditional if={!isRegisterPage}>
          <AuthenticatedTemplate>
            <button
              className="my-account-menu button"
              onClick={() => {
                removeLoggedInCookie()
                instance.logoutRedirect()
              }}
            >
              Logout
            </button>
          </AuthenticatedTemplate>
          <a
            className="open-search"
            tabIndex={0}
            href={govCMSHome}
            onClick={searchClick}
          >
            <span className="sr-only">Open search box</span>
            <Icon
              name="search"
              width="10"
              height="10"
              aria-label="Open search box"
            />
          </a>
        </Conditional>
      </header>

      <div id="header-supplement" className="mobile-only">
        <Conditional if={isRegisterPage}>
          <nav className="breadcrumbs dnd-s-mob">
            <ol>
              <li>
                <Link className="underline" to={PATHS.Register}>
                  Back to previous page
                </Link>
              </li>
            </ol>
          </nav>
        </Conditional>
        <Conditional if={!isRegisterPage}>
          <AuthenticatedTemplate>
            <div className="header-my-account-menu">
              <a
                href="#"
                className="button dropdown"
                id="myAccountButton"
                onClick={toggleClass}
              >
                My account
              </a>
              <ul className={isActive ? 'is-active' : ''}>
                <li>
                  <a href="/my-account/">Home</a>
                </li>
                <li>
                  <a href="/my-account/enquiries">Enquiries</a>
                </li>
                <li>
                  <a href="/my-account/resources">Resources</a>
                </li>
                <li>
                  <a href="/my-account/bookmarks">Bookmarks</a>
                </li>
                <li>
                  <a href="/my-account/profile">Profile</a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      removeLoggedInCookie()
                      instance.logoutRedirect()
                    }}
                    onKeyUp={() => {
                      removeLoggedInCookie()
                      instance.logoutRedirect()
                    }}
                    tabIndex={0}
                    role="button"
                  >
                    Log Out
                  </a>
                </li>
              </ul>
            </div>
          </AuthenticatedTemplate>
        </Conditional>

        <Conditional if={showMegamenu}>
          <UnauthenticatedTemplate>
            <p>
              <a
                className="button"
                id="authenticationButtonLogin"
                onClick={() => instance.loginRedirect()}
                onKeyUp={() => instance.loginRedirect()}
                tabIndex={0}
                role="button"
              >
                Login
              </a>
              <a className="button" href={registrationUrl}>
                Register
              </a>
            </p>
          </UnauthenticatedTemplate>
        </Conditional>
      </div>
    </>
  )
}
